import RefTreeComponet from './RefTreeComponet'
import { TopNavPage, NavUtils } from 'mutants-mobile-navigator';


@TopNavPage
export default class RefTreeNoBackEvent extends RefTreeComponet {
    isRegisterBackEvent() {
        return false;
    }
}
